import { Controller } from "@hotwired/stimulus"

// Generic checkbox-group toggle controller. Used by:
//   • the group-edit form ("Select all" / "Clear" inside one group)
//   • the generation-form's preset picker ("Select all in this group" buttons
//     above each group section)
//
// Group-scoped toggling: a button with `data-action="click->preset-picker#toggleGroup"`
// AND `data-preset-ids="1,5,7"` toggles ONLY the checkboxes whose value is in
// that comma-separated list — used to bulk-pick all presets that belong to a
// named group.
export default class extends Controller {
  static targets = ["checkbox"]

  selectAll() {
    this.checkboxTargets.forEach((cb) => { cb.checked = true; this.fire(cb) })
  }

  selectNone() {
    this.checkboxTargets.forEach((cb) => { cb.checked = false; this.fire(cb) })
  }

  // Toggle a subset by id list. `data-preset-ids="1,5,7"` on the trigger button.
  // First click: check all that are unchecked. If they're already all checked,
  // the click instead unchecks them all (acts as "deselect this group").
  toggleGroup(event) {
    const ids = (event.currentTarget.dataset.presetIds || "").split(",")
      .map((s) => s.trim()).filter(Boolean)
    if (ids.length === 0) return

    const targets = this.checkboxTargets.filter((cb) => ids.includes(String(cb.value)))
    if (targets.length === 0) return

    const allChecked = targets.every((cb) => cb.checked)
    targets.forEach((cb) => { cb.checked = !allChecked; this.fire(cb) })
  }

  // Dispatch a `change` event so any listeners (e.g. summary counters) catch up.
  fire(cb) {
    cb.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
